import Kijiji from './publishers/Kijiji'

/**
 * Publishers API
 */
export default class Publishers {
  constructor(axios) {
    this.$axios = axios

    this.Kijiji = new Kijiji(this.$axios)
  }
}
